













































import {
  defineComponent,
  ref,
  computed,
  useRouter,
  useContext,
  onMounted,
} from '@nuxtjs/composition-api';
import { addBasePath } from '~/helpers/addBasePath';
import { SfImage, SfSearchBar, SfButton } from '~/components/StorefrontUi';
import { clickOutside } from '~/components/directives/click-outside/click-outside-directive';

export default defineComponent({
  components: {
    SfImage,
    SfSearchBar,
    SfButton,
  },
  directives: { clickOutside },
  setup(props, { emit }) {
    const { localePath } = useContext();
    const router = useRouter();
    const term = ref('');

    const handleInput = (searchTerm: string) => {
      term.value = searchTerm;
    };
    const handleSearch = () => {
      if (!term.value) return;
      router.push({
        path: localePath('/sklep'),
        query: { search: term.value },
      });
    };
    const removeSearch = () => {
      if (!term.value) return;
      term.value = '';
      const query = { ...router.currentRoute.query };
      if (query.search) {
        delete query.search;
        router.replace({ query });
      }
    };

    const inputNotEmpty = computed(() => term.value.trim() !== '');

    const handleClickOutside = () => {
      emit('hideSearchbar');
    };

    onMounted(() => {
      const { currentRoute: { query } } = router;
      if (query.search) {
        term.value = query.search as string;
      }
    });

    return {
      removeSearch,
      addBasePath,
      term,
      inputNotEmpty,
      handleInput,
      handleSearch,
      handleClickOutside,
    };
  },
});
